import { type Conversation } from "shared/apiClient";
import { ConversationPhase, MessageType } from "shared/types";

import { useMessageTypeExists } from "@/hooks";
import { Noticeboard } from "shared/lib";
import { useGetReportContent } from "shared/hooks";

export function useIsReportGenerating(
  conversation: Conversation | undefined | null,
) {
  const amendmentExists = useMessageTypeExists({
    messageType: MessageType.AMENDMENT,
  });

  return (
    [
      ConversationPhase.ready_for_assessment,
      ConversationPhase.conv_routing,
    ].includes(conversation?.phase as any) && !amendmentExists
  );
}

export function useIsReportReGenerating(
  conversation: Conversation | undefined | null,
) {
  const amendmentExists = useMessageTypeExists({
    messageType: MessageType.AMENDMENT,
  });

  return (
    [
      ConversationPhase.ready_for_assessment,
      ConversationPhase.conv_routing,
    ].includes(conversation?.phase as any) && amendmentExists
  );
}

export function useGetDevelopmentActivityText(
  conversation: Conversation | undefined | null,
  noticeboardData: Noticeboard | undefined | null,
): string {
  const { getConfig } = useGetReportContent({
    conversation,
    noticeboardData,
  });

  const { content: developmentActivityText } = getConfig(
    `enquiry.development_activity`,
  );

  return developmentActivityText;
}
